import React from 'react'
import { object } from 'prop-types'
import { graphql } from 'gatsby'

import useZdassetsScript from 'hooks/useZdassetsScript'

import Layout from 'layouts/Layout'
import CartridgePage from 'components/CartridgePage'

const CartridgeTemplate = ({ data }) => {
  const { zdassetsScriptContainer } = useZdassetsScript()

  return (
    <Layout fullHeight lightFooter hideHeader>
      <CartridgePage
        cartridge={data.cartridge}
        collectionsContainingCartridge={data.collectionsContainingCartridge.nodes}
      />
      <div ref={zdassetsScriptContainer} />
    </Layout>
  )
}

CartridgeTemplate.propTypes = {
  data: object.isRequired
}

export default CartridgeTemplate

export const query = graphql`
  query($cartridgeHandle: String!) {
    cartridge: shopifyProduct(handle: { eq: $cartridgeHandle }) {
      id
      title
      handle
      description
      descriptionHtml
      priceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
        minVariantPrice {
          amount
          currencyCode
        }
      }
      variants {
        id
        title
        price
        sku
        image {
          originalSrc
          altText
        }
        availableForSale
      }
      images {
        originalSrc
        altText
      }
    }
    collectionsContainingCartridge: allShopifyCollection(
      filter: { products: { elemMatch: { handle: { eq: $cartridgeHandle } } } }
    ) {
      nodes {
        handle
        products {
          id
          title
          handle
          description
          descriptionHtml
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          variants {
            id
            title
            price
            sku
            image {
              originalSrc
              altText
            }
            availableForSale
          }
          images {
            originalSrc
            altText
          }
        }
      }
    }
  }
`
